import { createContext } from 'react';
import { ThemeContextValue } from './theme-types';
import palettes from './config/palleteConfig';

export const ThemeContext = createContext<ThemeContextValue>({
  theme: palettes.dark,
  isDark: true,
  setTheme: () => {}
});